const LabelList = {
	solution: 'Solution',
	condition: 'Condition',
	solution_task: 'Solution Task',
};

export default LabelList;
